import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-breadcrumbs",
  "aria-label": "Breadcrumb"
}
const _hoisted_2 = { class: "breadcrumb mb-0" }
const _hoisted_3 = ["aria-current"]
const _hoisted_4 = { key: 1 }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { resolveBreadcrumbs } from '@/router/breadcrumbs'
import { cuentaCorrienteClienteNombre } from '@/composables/cuentaCorrienteContext'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppBreadcrumbs',
  setup(__props) {

const route = useRoute()

const items = computed(() => {
  const resolved = resolveBreadcrumbs(route)
  if (route.name !== 'CuentaCorriente' || !cuentaCorrienteClienteNombre.value || !resolved.length) {
    return resolved
  }

  return resolved.map((item, index) =>
    index === resolved.length - 1
      ? { ...item, label: `Cuenta corriente - ${cuentaCorrienteClienteNombre.value}` }
      : item
  )
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (items.value.length > 0)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("ol", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `${item.label}-${index}`,
              class: _normalizeClass(["breadcrumb-item", { active: index === items.value.length - 1 }]),
              "aria-current": index === items.value.length - 1 ? 'page' : undefined
            }, [
              (item.to && index !== items.value.length - 1)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: item.to
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.label), 1))
            ], 10, _hoisted_3))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})